import _get from 'lodash/get';
import { DEFAULT_MODE, hexToARGB } from '@tornado-rdk/theme';

export const getLayoutTheme = (theme, parentTheme = undefined) => {
  const source = theme || {};
  const parent = parentTheme || {};

  const result = {
    backgroundColor: hexToARGB(source.backgroundColor, 1),
    backgroundImage: _get(source, 'backgroundImage.id') || '',
    foregroundImage: _get(source, 'foregroundImage.id') || '',
    colorScheme: source.colorScheme || parent.colorScheme || DEFAULT_MODE,
  };

  return result;
};
